import Marquee from "react-fast-marquee";
import items from "./SliderVideos.json";
import Video from "./Video";
import Button from "../../elements/buttons/Button";
import { NavLink } from "react-router-dom";

const SliderVideos = () => {
  return (
    <div className="slidervideos-container">
      <div className="only-mobile">
        <Marquee gradient={false} speed={40} pauseOnHover={true}>
          {items.map((video) => {
            return (
              <Video
                key={video.id}
                categoria={video.categoria}
                link={video.link}
                titulo={video.titulo}
                screenshot={video.screenshot}
              />
            );
          })}
        </Marquee>
      </div>
      <Marquee gradient={false} speed={30} pauseOnHover={true}>
        {items.map((video) => {
          return (
            <Video
              key={video.id}
              categoria={video.categoria}
              link={video.link}
              titulo={video.titulo}
              screenshot={video.screenshot}
            />
          );
        })}
      </Marquee>
      <div className="button-inline" style={{ padding: "75px 0" }}>
        <NavLink to="/cartelera" className="button button-primary">
          Ver cartelera
        </NavLink>
      </div>
    </div>
  );
};

export default SliderVideos;
